import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/nl/diensten", "nl", "services");
